import { Form } from 'react-bootstrap';
import "../assets/css/background-colors.css";
import image4 from '../assets/images/GapsphereLoading.gif';

// ==Loading icons ===========

const apiSessionId = sessionStorage.getItem("sessionId");
console.log("sessionId", apiSessionId);


export const LoadingIcon = () => {
  return (
    <div>
      <main
        className="d-flex justify-content-center align-items-center"
        style={{ height: "calc(100vh - 80px)" }}
      >
        <img
          src={image4}
          alt="Loading..."
          style={{ width: "114px", height: "109px" }}
        />
      </main>
    </div>
  );
};


export const TableLoading = () => {
  return (
    <div>
      <img
        src={image4}
        alt="Loading..."
        style={{ width: "114px", height: "109px" }}
      />
    </div>
  );
};

export const UploadLoadingIcon = () => {
  return (
    <div>
      <main
        className="d-flex justify-content-center align-items-center"
        style={{ height: "calc(100vh - 80px)" }}
      >
        <img
          src={image4}
          alt="Loading..."
          style={{ width: "114px", height: "109px" }}
        />
      </main>
    </div>
  );
};


// =================================Header ==========================
export const HeadingStyle = {
  fontSize: '24px', // Adjust the font size as needed
  textAlign: 'center',
};

const getCssVariable = (variable) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
};

export const ListPopSize = {
  fontSize: '14px'
}


// having the card header page 
export const cardheader = {
  fontSize: '20px'
}
export const h1 = {
  fontSize: '2.5rem', // 40px
};

export const h2 = {
  fontSize: '2rem', // 32px
};

export const h3 = {
  fontSize: '1.75rem', // 28px
};

export const h4 = {
  fontSize: '1.5rem', // 24px
};

export const h5 = {
  fontSize: '1.25rem', // 20px
};

export const h6 = {
  fontSize: '1rem', // 16px
};

export const h7 = {
  fontSize: '0.875rem', // 14px (custom size for h7)
};


export const AlertModal = ({ showModal, handleModalClose, modalMessage, messageType }) => {
  // Close button style
  const closeButtonStyle = {
    // backgroundColor: '#',
    border: 'none',
    color: 'white',
    fontSize: '14px',
    padding: '5px 15px',
  };


  return (
    <div className={`modal fade ${showModal ? 'show' : ''}`}
      tabIndex="-1"
      role="dialog"
      style={{ display: showModal ? 'block' : 'none' }}
      onClick={() => handleModalClose()}>
      <div className="modal-dialog" role="document" style={{ marginTop: '10vh' }}>
        <div className="modal-content" style={{ overflowY: 'auto', fontSize: "15px" }}>
          {/* Modal Header with Conditional Background Color */}
          <div className="modal-header"
            style={{
              backgroundColor: modalMessage === 'Data submitted.' ? '#339966' : // Green for success
                (messageType === 'warning' ? '#ffcc00' : '#ff4d4d') // Yellow for warning, red for error
            }}>
            <h5 className="modal-title" style={{ color: 'black', position: 'relative', padding: '2px 10px', lineHeight: '1.0' }}>
              Notification
            </h5>
          </div>

          {/* Modal Body with Conditional Text Color */}
          <div className="modal-body" style={{ fontSize: '16px' }}>
            <p style={{
              color: modalMessage === 'Data submitted.' ? 'white' : // White for success message
                (messageType === 'warning' ? 'black' : 'black') // Black for warning and error messages
            }}
              dangerouslySetInnerHTML={{ __html: modalMessage }} />
          </div>

          {/* Modal Footer with Close Button */}
          <div className="modal-footer" style={{ padding: '2px 15px', lineHeight: '1.2' }}>
            <button type="button" className="btn btn-secondary" onClick={() => handleModalClose()}
              style={closeButtonStyle}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export const Listoftablesearchbox = ({ searchQuery, onSearchChange }) => {
  return (
    <input
      type="text"
      className="form-control ms-5"
      style={{ width: '240px', marginLeft: '20px' }}
      placeholder="Search..."
      value={searchQuery}
      onChange={onSearchChange}
    />
  );
};

export const Listoftablesearchbox1 = ({ searchQuery, onSearchChange }) => {
  return (

    <input
      type="text"
      className="form-control form-control-sm w-100"
      placeholder="Search..."
      value={searchQuery}
      onChange={onSearchChange}
    />
  );
};

// ==============================Footer================================================
export const Footer = () => {
  return (
    <footer className="footer fixed-bottom">
      <div className="container">
        <div className="text-center mt-3">
          <small style={{ fontSize: '14px' }}>
            Copyright &copy; 2023 RecycCore Innovations. All Rights Reserved
          </small>
        </div>
      </div>
    </footer>
  );
};


// =====================================Back Button==========================

export const BackButton = (props) => {
  return (
    <button
      {...props}
      className={`btn btn-sm ${props.className || ''}`} // Allow className to be passed
      data-toggle="tooltip"
      data-placement="Left"
      title="Back to previous page"
      style={{
        backgroundColor: "var(--button-background)",
        color: "var(--whitefont-color)",
        boxShadow: "var(--button-box-shadow)",
        // marginLeft: "9px",
        border: "1px solid var(--button-background)", // Keep border consistent
        ...props.style // Allow custom styles to be passed
      }}
    >
      Back
    </button>
  );
};

// =============================================================
// =======Approve Button styles ========
export const CommonButtonclasss = "btn btn-light btn-sm custom-btn";
export const bootstrapbuttonclass = "btn btn-secondary";

export const approveButtonStyle = {
  backgroundColor: '#0a66c2',
  border: '1px solid #0a66c2',
  color: 'black',
  padding: '2px',
  fontSize: '12px',
  overflow: 'hidden', // Hides overflow text
};

export const rejectButtonStyle = {
  backgroundColor: '#df2c14',
  border: '1px solid #df2c14',
  padding: '2px',
  color: 'white',
  fontSize: '12px',
  overflow: 'hidden', // Hides overflow text

};

export const DownloadButtonStyle = {

  backgroundColor: "#0a66c2",
  color: "black",
  border: '1px solid #0a66c2',
  marginRight: '10px'

};

export const RetrieveButton = {
  backgroundColor: '#0a66c2',
  borderColor: 'transparent',
  marginRight: '10px', color: 'black'
};

export const previewButtonStyle = {
  backgroundColor: '#0a66c2',
  border: '1px solid #0a66c2',
  padding: '2px',
  fontSize: '12px',
  color: 'white',
  overflow: 'hidden', // Hides overflow text
};

export const RestoreButtonStyle = {
  backgroundColor: '#0a66c2',
  border: '1px solid #0a66c2',
  padding: '2px',
  fontSize: '12px',
  color: 'black',
  overflow: 'hidden', // Hides overflow text
};

export const ResetButton = {
  backgroundColor: "#0a66c2",
  fontSize: '14px',
  border: '1px solid #0a66c2',
  textAlign: 'center'
};

export const closeButtonStyle = {
  backgroundColor: getCssVariable('--close-btn-bg-color'),
  color: getCssVariable('--close-btn-txt-color'),
  border: 'none'
};



export const cancelButtonStyle = {
  // // backgroundColor: '#df2c14',
  // color: 'white',
  backgroundColor: getCssVariable('--cancel-btn-bg-color'),
  color: getCssVariable('--cancel-btn-txt-color'),

};


export const ResetButtonStyle = {
  // // backgroundColor: '#df2c14',
  // color: 'white',
  backgroundColor: getCssVariable('--reset-btn-bg-color'),
  color: getCssVariable('--reset-btn-txt-color'),

};


export const DeleteButtonStyle = {
  backgroundColor: '#df2c14',
  color: 'white',
  border: 'none'
};


export const submitButtonStyle = {
  // backgroundColor: '#0a66c2',
  backgroundColor: getCssVariable('--button-background-Submit'),
  color: getCssVariable('--button-background-Submit-txt'),
  border: 'none'
};

export const ConformButtonStyle = {
  // backgroundColor: '#0a66c2',
  backgroundColor: getCssVariable('--Conform-btn-bg-color'),
  color: getCssVariable('--Conform-btn-txt-color'),
  border: 'none'
};

export const DeletingButtonStyle = {
  // backgroundColor: '#0a66c2',
  backgroundColor: getCssVariable('--button-background-Delete'),
  color: getCssVariable('--button-background-Delete-txt'),
  border: 'none'
};



export const ProceedButtonStyle = {
  // backgroundColor: '#0a66c2',
  backgroundColor: getCssVariable('--Proceed-btn-bg-color'),
  color: getCssVariable('--Proceed-btn-txt-color'),
  border: 'none'
};



export const YesadConformBtn = {
  // backgroundColor: '#0a66c2',
  backgroundColor: getCssVariable('--Yes-conform-btn-color'),
  color: getCssVariable('--Yes-conform-btn-txt-color'),
  border: 'none'
};


export const GenerateReportBtn = {
  backgroundColor: getCssVariable('--button-background-Generate-Report'),
  color: getCssVariable('--button-background-Generate-Report-txt'),
  border: 'none'
};


export const GeneratePasswordBtn = {
  backgroundColor: getCssVariable('--button-background-Generate-password'),
  color: getCssVariable('--button-background-Generate-password-txt'),
  border: 'none'
};


export const UploadButtonStyle = {
  backgroundColor: getCssVariable('--Upload-btn-bg-color'),
  color: getCssVariable('--Upload-btn-txt-color'),
  border: 'none'
};


export const Updatebuttonstyle = {
  backgroundColor: getCssVariable('--update-btn-bg-color'),
  color: getCssVariable('--update-btn-txt-color'),
  border: 'none'
};


export const Saveandadduser = {
  backgroundColor: getCssVariable('--Save--addUser-btn-color'),
  color: getCssVariable('--save--adduser-txt-color'),
  border: 'none'
};


export const PreViewButton = {
  backgroundColor: getCssVariable('--Preview-btn-bg-color'),
  color: getCssVariable('--preview-btn-txt-color'),
  border: 'none'
};



// ======================Below the button color is based upon table  ======================= 

export const Editcolor = {
  backgroundColor: getCssVariable('--Edit-btn-bg-color'),
};

export const Deletecolor = {
  backgroundColor: '#0a66c2',
};
export const submit = {
  backgroundColor: getCssVariable('--button-background-Submit'),
}
export const Cancelcolor = {
  backgroundColor: '#df2c14',
};

export const Aprrovecolor = {
  backgroundColor: '#28A745',
  border: '#28A745',
}
export const Rejectcolor = {
  backgroundColor: '#df2c14',
  border: '#df2c14',
};

export const Retrievecolor = {
  backgroundColor: '#0a66c2',
};


export const Formlable = {
  Color: 'black',
};


export const iconStyle = {
  color: '#E67016', // Common icon color
};

export const SearchBox = ({ searchTerm, handleSearch }) => (
  <div>
    <input
      type="text"
      value={searchTerm}
      onChange={handleSearch}
      placeholder="Search..."
      className="form-control form-control-sm w-100"
    />
  </div>
);

export const SearchInput = ({ searchInputRef, search, setSearch, placeholder = "Search..." }) => (
  <Form.Control
    ref={searchInputRef}
    type="text"
    placeholder={placeholder}
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    className="form-control"
  />
);

export const RecordsPerPageSelect = ({ recordsPerPage, handleRecordsPerPageChange }) => {
  const options = [10, 20, 30, 40, 50];

  return (
    <select className="form-select" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
      {options.map(option => (
        <option key={option} value={option}>{option}</option>
      ))}
    </select>
  );
};


export const RecordsPerPageDropdown = ({ recordsPerPage, setRecordsPerPage }) => {
  const options = [10, 20, 30, 40, 50];

  const handleChange = (event) => {
    const selectedValue = parseInt(event.target.value, 10);
    setRecordsPerPage(selectedValue);
  };

  return (
    <select className="form-select" value={recordsPerPage} onChange={handleChange}>
      {options.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </select>
  );
};


export const getFilteredData = (data, columnsToDisplay, search) => {
  const hiddenColumns = ["created_by", "created_dt", "modified_dt", "modified_by", "active_yn"];

  return data
    .filter(row => row.Rejected_Reason && row.Rejected_Reason !== "\\N" && row.Rejected_Reason.trim() !== '')
    .filter(row => row.active_yn !== "N" && row.active_yn !== 'N')
    .filter(row => row.dataModel === "BDM")
    .filter(row =>
      columnsToDisplay.some(column =>
        String(row[column] || "").toLowerCase().includes(search.toLowerCase())
      )
    )
    .map(row => {
      const filteredRow = { ...row };
      hiddenColumns.forEach(col => delete filteredRow[col]);
      return filteredRow;
    });
};


export const getFilteredData1 = (data, columnsToDisplay, search) => {
  const hiddenColumns = ["created_by", "created_dt", "modified_dt", "modified_by", "active_yn"];

  return data
    .filter(row => row.Rejected_Reason && row.Rejected_Reason !== "\\N" && row.Rejected_Reason.trim() !== '')
    .filter(row => row.active_yn !== "N" && row.active_yn !== 'N')
    .filter(row => row.dataModel === "DEM")
    .filter(row =>
      columnsToDisplay.some(column =>
        String(row[column] || "").toLowerCase().includes(search.toLowerCase())
      )
    )
    .map(row => {
      const filteredRow = { ...row };
      hiddenColumns.forEach(col => delete filteredRow[col]);
      return filteredRow;
    });
};

const formatDate = (inputDate) => {
  if (!inputDate) return "";
  const date = new Date(inputDate);
  return date.toISOString().split("T")[0];
};


export const getRetrievedBDMData = (data, columnsToDisplay, search, reportingDate) => {
  const hiddenColumns = ["created_by", "created_dt", "modified_dt", "modified_by", "active_yn", "approved_by", "approved_dt", "Maker_Remarks", "Rejected_Reason", "flag"];

  return data
    .filter(row => {
      const matchesDataModel = row.dataModel === "BDM";
      const matchesSearch = columnsToDisplay.some(column =>
        String(row[column] || "").toLowerCase().includes(search.toLowerCase())
      );
      const matchesDate = !reportingDate || formatDate(row.reporting_date) === reportingDate;

      return matchesDataModel && matchesSearch && matchesDate;
    })
    .map(row => {
      const filteredRow = { ...row };
      hiddenColumns.forEach(col => delete filteredRow[col]);
      return filteredRow;
    });
};

export const getRetrievedDEMData = (data, columnsToDisplay, search, reportingDate) => {
  const hiddenColumns = ["created_by", "created_dt", "modified_dt", "modified_by", "active_yn", "approved_by", "approved_dt", "Maker_Remarks", "Rejected_Reason", "flag"];

  return data
    .filter(row => {
      const matchesDataModel = row.dataModel === "DEM";
      const matchesSearch = columnsToDisplay.some(column =>
        String(row[column] || "").toLowerCase().includes(search.toLowerCase())
      );
      const matchesDate = !reportingDate || formatDate(row.reporting_date) === reportingDate;

      return matchesDataModel && matchesSearch && matchesDate;
    })
    .map(row => {
      const filteredRow = { ...row };
      hiddenColumns.forEach(col => delete filteredRow[col]);
      return filteredRow;
    });
};
export const getModifiedBDMData = (data, columnsToDisplay, search, reportingDate) => {
  const hiddenColumns = ["created_by", "created_dt", "modified_dt", "modified_by", "active_yn", "approved_by", "approved_dt", "Maker_Remarks"];

  return data
    .filter(row => {
      const matchesDataModel = row.dataModel === "BDM";
      const isFlagR = row.flag === "R";

      const rejectedReason = row.Rejected_Reason?.trim();
      const excludedReasons = ["\\N", "\\\\N", "\\\\\\N", "NULL", ""];

      const hasValidRejectedReason = rejectedReason && !excludedReasons.includes(rejectedReason);

      const matchesSearch = columnsToDisplay.some(column =>
        String(row[column] || "").toLowerCase().includes(search.toLowerCase())
      );
      const matchesDate = !reportingDate || formatDate(row.reporting_date) === reportingDate;

      return matchesDataModel && isFlagR && hasValidRejectedReason && matchesSearch && matchesDate;
    })
    .map(row => {
      const filteredRow = { ...row };
      hiddenColumns.forEach(col => delete filteredRow[col]);
      return filteredRow;
    });
};


export const getModifiedDEMData = (data, columnsToDisplay, search, reportingDate) => {
  const hiddenColumns = ["created_by", "created_dt", "modified_dt", "modified_by", "active_yn", "approved_by", "approved_dt", "Maker_Remarks"];

  return data
    .filter(row => {
      const matchesDataModel = row.dataModel === "DEM";
      const isFlagR = row.flag === "R";

      const rejectedReason = row.Rejected_Reason?.trim();
      const excludedReasons = ["\\N", "\\\\N", "\\\\\\N", "NULL", ""];

      const hasValidRejectedReason = rejectedReason && !excludedReasons.includes(rejectedReason);

      const matchesSearch = columnsToDisplay.some(column =>
        String(row[column] || "").toLowerCase().includes(search.toLowerCase())
      );
      const matchesDate = !reportingDate || formatDate(row.reporting_date) === reportingDate;

      return matchesDataModel && isFlagR && hasValidRejectedReason && matchesSearch && matchesDate;
    })
    .map(row => {
      const filteredRow = { ...row };
      hiddenColumns.forEach(col => delete filteredRow[col]);
      return filteredRow;
    });
};


export const Pagination = ({ totalPages, currentPage, paginate }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="pagination-container" style={{ display: 'flex', justifyContent: 'center', marginTop: '1%' }}>
      <nav aria-label="Page navigation">
        <ul className="pagination">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              style={{ color: '#E67016' }}
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
          </li>
          {Array.from({ length: totalPages }, (_, index) => (
            <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
              <button
                className="page-link"
                style={{ color: '#E67016' }}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              style={{ color: '#E67016' }}
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};
// ==================================================================

export const ViewAllbutton = (props) => {
  return (
    <button
      {...props}
      className="btn btn-sm"
      data-toggle="tooltip"
      data-placement="bottom"
      title="Click to view "
      style={{ backgroundColor: '#26b7ec', color: 'black', border: '1px solid #26b7ec' }}>
      View All
    </button>
  );
};

// ====================RetrieveCheckermodify RDM and BDM and DEM for 3 pages 1.  =====================

// config.js

export const getUrlParam = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};


export const getConfigRetrivalApprove = (paramValue, approveRowId) => ({
  headers: {
    "userId": localStorage.getItem('userid')
  },
  params: {
    "tableName": paramValue,
    "rowId": approveRowId,
    "approveStatus": "Y",
    "dataModel": "MASTERS",
    "rejectedReason": "",
  }
});

export const getConfigRetrivalReject = (paramValue, clickedRowId, rejectedReason, notificationType) => ({
  headers: {
    "userId": localStorage.getItem('userid')
  },
  params: {
    "tableName": paramValue,
    "rowId": clickedRowId,
    "approveStatus": "N",
    "rejectedReason": rejectedReason,
    "dataModel": "MASTERS",
    "Notifications": notificationType,
  }
});


export const getConfig_Retrieve = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get('param');

  return {
    headers: { "userId": localStorage.getItem('userid') },
    params: { "tableName": `${paramValue}_retrieved` }
  };
};


export const createConfig = (fileName) => {
  return {
    headers: { "userId": localStorage.getItem('userid') },
    params: { "tableName": fileName }
  };
};

// **********************************************************************************************************************************
const filterRejectedRecords = (data) => {
  return data.filter(item => (
    item.Rejected_Reason !== "Ready for validation. (updated)" &&
    item.Rejected_Reason !== "\\N" &&
    item.Rejected_Reason !== "" && item.Rejected_Reason !== "\N") && (
      item.active_yn !== 'N' && item.active_yn !== "N"
    ));
};


// =======================================================================================================


export default filterRejectedRecords;
